import styled from 'styled-components';

export const LoaderWrapper = styled.div`
	position: absolute;
	height: 15%;
	aspect-ratio: 1;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: opacity 0.5s ease-in-out;
	z-index: 1000;

	&[data-delay-display='true']&:not(.hidden) {
		animation: appear 0.8s ease-in-out 1.25s forwards;
		opacity: 0;
	}

	@keyframes appear {
		from {
			opacity: 0;
		}
		to {
			opacity: 0.7;
		}
	}

	&[ data-is-displayed='false' ] {
		opacity: 0 !important;
	}

`

export const Loader = styled.div`
	width: 100%;
	height: 100%;
	border: 1px solid var(--bg-main);
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;